export const text = {
  PROVIDER: 'PROVIDER',
  PATIENT: 'Patient: ',
}
export const styles = {
  TITLES_TOOLTIP: {
    top: 28,
    height: 'max-content',
    marginLeft: 'auto',
    marginRight: 'auto',
    right: 0,
    left: 0,
    width: 'calc(100% - 48px)',
    pointerEvents: 'none',
  },
  NAME_TOOLTIP: {
    top: 0,
    height: 'max-content',
    marginLeft: 'auto',
    marginRight: 'auto',
    right: 0,
    left: 0,
    width: 'calc(100% - 48px)',
    pointerEvents: 'none',
  },
}
